/**
 * Extract the tenant subdomain from the current hostname.
 *
 * Rules:
 * - "client.ab3.kz"  → "client"
 * - "app.ab3.kz"     → null  (main app domain)
 * - "localhost"       → null
 * - "192.168.x.x"    → null  (IP address)
 * - "ab3.kz"         → null  (bare domain)
 */

const MAIN_SUBDOMAINS = new Set(['app', 'www', 'admin']);
const IP_REGEX = /^\d{1,3}(\.\d{1,3}){3}$/;

export function getSubdomain(hostname: string = window.location.hostname): string | null {
  // localhost or IP — no subdomain
  if (hostname === 'localhost' || IP_REGEX.test(hostname)) {
    return null;
  }

  const parts = hostname.split('.');

  // Need at least 3 parts: subdomain.domain.tld
  if (parts.length < 3) {
    return null;
  }

  const subdomain = parts[0];

  // Skip known main subdomains
  if (MAIN_SUBDOMAINS.has(subdomain)) {
    return null;
  }

  return subdomain;
}

/**
 * Extract ?org= slug from current URL query params.
 */
export function getOrgSlugFromQuery(): string | null {
  const params = new URLSearchParams(window.location.search);
  return params.get('org') || null;
}
